import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import styled from 'styled-components';
import Stack from '@mui/material/Stack';
import { useDispatch } from 'react-redux';
import './Card.css';
import {fetchPlan,createPlan} from 'store/planSlice';

const Text = styled.h5``;
const ResponsiveDialog = () => {
  const [open, setOpen] = useState(false);
  const [plan, setPlan] = useState({
    planName: "", desc: ""
  });
  const [err, setErr] = useState("");
  const dispatch = useDispatch();


  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setPlan({ ...plan, [name]: value })
  }
  const { planName, desc } = plan;
  const payload = {
    "plan_name": planName,
    "desc": desc
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await dispatch(createPlan(payload));
      setPlan({ plan: "", desc: "" });
      handleClose();
      await dispatch(fetchPlan());
    }
    catch (err) {
      setErr(err);
    }
  }
  return (
    <div>
      <button className="addPlan" onClick={handleClickOpen}>Add Plan</button>
      <Dialog open={open} onClose={handleClose} sx={{'& .MuiDialog-paper' :{
        width:'400px'
      }}} >
        {err && <div className="err">{err}</div>}
        <DialogTitle >{"Planning"}</DialogTitle>
        <DialogContent  >
          <Box component="form" onSubmit={handleSubmit}
            sx={{
              '& > :not(style)': { m: 1, width: '93%', },
            }}
            
          >
            <Text>Plan Name</Text>
            <TextField name='planName' id="outlined-basic" variant="outlined" value={plan.plan} onChange={handleInput}
              placeholder='Plan Name' required  sx={{'& .MuiOutlinedInput-notchedOutline':{
                borderRadius:'12px'
              }
             }}/>
            <Text>Description</Text>
            <TextField name='desc' id="outlined-basic" variant="outlined" value={plan.desc}
              onChange={handleInput}
              placeholder='Description'
              sx={{'& .MuiOutlinedInput-notchedOutline':{
                borderRadius:'12px'
              }
             }} />
            {/* <Stack spacing={2} direction="row">
              <Button style={{ padding: "12px 79px", margin: '15px 0px' }} variant="contained">Add Task Inside Your Plan</Button>
            </Stack> */}
            <DialogActions type='submit'>
              <Button autoFocus onClick={handleClose}>
                Cancel
              </Button>
              <Button type='submit' autoFocus>
                Save
              </Button>
            </DialogActions>
          </Box  >
        </DialogContent>
      </Dialog>
    </div>
  );
}
export default ResponsiveDialog